import { Text } from 'shared/ui/common/Text'
import { Button } from 'shared/ui/controls/Button'
import { ProgressBar } from 'shared/ui/common/ProgressBar'

import s from './NFCSRetrieving.module.scss'

type Props = {
  onClose?: () => void
}

export function NFCSRetrieving({ onClose }: Props) {
  return (
    <>
      <Text size={16} weight={600} isUppercased isCentered className={s.text}>
        Your credit score is being retrieved
      </Text>

      <ProgressBar className={s.progress} />

      {onClose && (
        <Button isCentered size={60} fashion="glass" onClick={onClose}>
          Close
        </Button>
      )}
    </>
  )
}
